export const MARKETING_WEBSITE =
  process.env.NEXT_PUBLIC_MARKETING_WEBSITE ?? 'https://schools.campuslush.com';
